import { render, staticRenderFns } from "./VideoHotcodeMaterial.vue?vue&type=template&id=a605b066&scoped=true"
import script from "./VideoHotcodeMaterial.vue?vue&type=script&lang=js"
export * from "./VideoHotcodeMaterial.vue?vue&type=script&lang=js"
import style0 from "./VideoHotcodeMaterial.vue?vue&type=style&index=0&id=a605b066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a605b066",
  null
  
)

export default component.exports